import marked from "marked";
/** Using a map as a string->value cache with no purging */
const contentCache = new Map();
const jsonCache = new Map();
/**
 * Returns a potentially promising function which will load requested
 * markdown content and parse to HTML on demand.
 */
export function loadContent(filename, initialOptions = {}) {
    const existingContent = contentCache.get(filename);
    if (existingContent)
        return existingContent;
    return (async () => {
        const response = await fetch(`/content/${filename}`);
        const rawMarkdown = await response.text();
        const [rawTitle, ...rawContent] = rawMarkdown.split("\n");
        const title = rawTitle.replace(/\#/g, "").trim();
        const html = marked(rawContent.join("\n"), {
            walkTokens: (token) => {
                switch (token.type) {
                    case "heading": {
                        token.depth += 1;
                        break;
                    }
                    case "image": {
                        token.href = `content/${token.href}`;
                    }
                }
            },
        });
        const content = { title, html, options: initialOptions };
        contentCache.set(filename, content);
        return content;
    })();
}
/** Loads a JSON resource, does no validation but does provide key-based caching */
export function loadJSON(uri, options = {}) {
    const existingJSON = jsonCache.get(uri);
    if (existingJSON)
        return existingJSON;
    return (async () => {
        const response = await fetch(uri);
        const json = (await response.json());
        if (!options.alwaysReload) {
            jsonCache.set(uri, json);
        }
        return json;
    })();
}
